var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatternNv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 21C22.3431 21 21 22.3431 21 24C21 25.6569 22.3431 27 24 27C25.6569 27 27 25.6569 27 24C27 22.3431 25.6569 21 24 21ZM19 24C19 21.2386 21.2386 19 24 19C26.7614 19 29 21.2386 29 24C29 26.7614 26.7614 29 24 29C21.2386 29 19 26.7614 19 24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 21C36.3431 21 35 22.3431 35 24C35 25.6569 36.3431 27 38 27C39.6569 27 41 25.6569 41 24C41 22.3431 39.6569 21 38 21ZM33 24C33 21.2386 35.2386 19 38 19C40.7614 19 43 21.2386 43 24C43 26.7614 40.7614 29 38 29C35.2386 29 33 26.7614 33 24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 21C8.34315 21 7 22.3431 7 24C7 25.6569 8.34315 27 10 27C11.6569 27 13 25.6569 13 24C13 22.3431 11.6569 21 10 21ZM5 24C5 21.2386 7.23858 19 10 19C12.7614 19 15 21.2386 15 24C15 26.7614 12.7614 29 10 29C7.23858 29 5 26.7614 5 24Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 35C22.3431 35 21 36.3431 21 38C21 39.6569 22.3431 41 24 41C25.6569 41 27 39.6569 27 38C27 36.3431 25.6569 35 24 35ZM19 38C19 35.2386 21.2386 33 24 33C26.7614 33 29 35.2386 29 38C29 40.7614 26.7614 43 24 43C21.2386 43 19 40.7614 19 38Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 35C36.3431 35 35 36.3431 35 38C35 39.6569 36.3431 41 38 41C39.6569 41 41 39.6569 41 38C41 36.3431 39.6569 35 38 35ZM33 38C33 35.2386 35.2386 33 38 33C40.7614 33 43 35.2386 43 38C43 40.7614 40.7614 43 38 43C35.2386 43 33 40.7614 33 38Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 35C8.34315 35 7 36.3431 7 38C7 39.6569 8.34315 41 10 41C11.6569 41 13 39.6569 13 38C13 36.3431 11.6569 35 10 35ZM5 38C5 35.2386 7.23858 33 10 33C12.7614 33 15 35.2386 15 38C15 40.7614 12.7614 43 10 43C7.23858 43 5 40.7614 5 38Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 7C22.3431 7 21 8.34315 21 10C21 11.6569 22.3431 13 24 13C25.6569 13 27 11.6569 27 10C27 8.34315 25.6569 7 24 7ZM19 10C19 7.23858 21.2386 5 24 5C26.7614 5 29 7.23858 29 10C29 12.7614 26.7614 15 24 15C21.2386 15 19 12.7614 19 10Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 7C36.3431 7 35 8.34315 35 10C35 11.6569 36.3431 13 38 13C39.6569 13 41 11.6569 41 10C41 8.34315 39.6569 7 38 7ZM33.1 9C33.5633 6.71776 35.581 5 38 5C40.7614 5 43 7.23858 43 10C43 12.419 41.2822 14.4367 39 14.9V20H37V14.9C35.0409 14.5023 33.4977 12.9591 33.1 11H28V9H33.1ZM23 20V14H25V20H23ZM11 28V34H9V28H11ZM23 34V28H25V34H23ZM14 37H20V39H14V37Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternNv);
export default __webpack_public_path__ + "static/media/Pattern_nv.7a2890b9a49054bdfc9e453486cb494b.svg";
export { ForwardRef as ReactComponent };